import { QUESTIONS } from "../data/auditQuestions"

const delay = ms => new Promise(res => setTimeout(res, ms))

const API_BASE = 'https://staging.visiomate.com'
// const API_BASE = 'http://127.0.0.1:5001'

export const startAuditSession = async () => {
  await delay(300)
  return {
    sessionId: `vm_audit_${Date.now()}`,
    question: QUESTIONS[0],
  }
}

export const submitAuditAnswer = async ({ sessionId, questionId, answer }) => {
  await delay(350)
  const idx = QUESTIONS.findIndex(q => q.id === questionId)
  if (idx === -1 || idx === QUESTIONS.length - 1) {
    return { done: true }
  }
  return { question: QUESTIONS[idx + 1] }
}

export const sendAuditEmail = async ({ report, name, email }) => {
  const res = await fetch(`${API_BASE}/api/send-audit-email`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ report, name, email }),
  })
  if (!res.ok) {
    const err = await res.json().catch(() => ({}))
    throw new Error(err.error || "Email sending failed")
  }
  return res.json()
}

export const submitAudit = async ({ sessionId, answers, firstName, lastName, company, designation, email, country }) => {
  const res = await fetch(`${API_BASE}/api/submit-audit`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ sessionId, answers, firstName, lastName, company, designation, email, country }),
  })
  if (!res.ok) {
    const err = await res.json().catch(() => ({}))
    throw new Error(err.error || "Submission failed")
  }
  return res.json()
}

export const generateDynamicQuestions = async ({ staticAnswers, userInfo }) => {
  const res = await fetch(`${API_BASE}/api/generate-dynamic-questions`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ staticAnswers, userInfo }),
  })
  if (!res.ok) {
    const err = await res.json().catch(() => ({}))
    throw new Error(err.error || "Failed to generate questions")
  }
  return res.json()
}

export const generateCompanySummary = async ({ allAnswers, userInfo }) => {
  const res = await fetch(`${API_BASE}/api/generate-company-summary`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ allAnswers, userInfo }),
  })
  if (!res.ok) {
    const err = await res.json().catch(() => ({}))
    throw new Error(err.error || "Failed to generate summary")
  }
  return res.json()
}
